import { VALID_GUESSES } from '../constants/validGuesses'
import {
  WRONG_SPOT_MESSAGE,
  PRESENT_NOT_CONTAINED_MESSAGE,
  OTHER_NOT_CONTAINED_MESSAGE,
} from '../constants/strings'
import { WORD_LENGTH } from '../constants/settings'
import { NEW_WORDS } from '../constants/wordlist'
import { OLD_WORDS } from '../constants/oldWordlist'
import { WORD_COUNT } from '../constants/countSpecific'
import { getGuessStatuses } from './statuses'
import { default as GraphemeSplitter } from 'grapheme-splitter'

// build a set of previously revealed letters - present and correct
// guess must use correct letters in that space and any other revealed letters
// also check if all revealed instances of a letter are used (i.e. two C's)
export const findFirstUnusedReveal = (word: string, guesses: string[]) => {
  if (guesses.length === 0) {
    return false
  }

  //const lettersLeftArray = new Array<string>()
  const guess = guesses[guesses.length - 1]
  const statuses = getGuessStatuses(guess)

  var wordCopy = (' ' + word).slice(1)
  for (let ii = 0; ii < guess.length; ii++) {
    if (statuses[ii] === 'correct') {
      if (wordCopy[ii] !== guess[ii]) {
        return WRONG_SPOT_MESSAGE(guess[ii], ii + 1)
      } else {
        wordCopy = wordCopy.substring(0, ii) + ' ' + wordCopy.substring(ii + 1)
      }
      //console.debug("found correct - word=" + wordCopy);
    }
  }

  for (let ii = 0; ii < guess.length; ii++) {
    if (statuses[ii] === 'present') {
      let st = ii - (ii % WORD_LENGTH)
      let en = st + WORD_LENGTH
      let ind = wordCopy.substring(st, en).indexOf(guess[ii])
      //console.debug("present looking for " + guess[ii] + " in " + wordCopy.substring(st, en) + ", st=" + st + ", en=" +en + ", ind=" + ind)
      if (ind !== -1) {
        wordCopy =
          wordCopy.substring(0, st + ind) +
          ' ' +
          wordCopy.substring(st + ind + 1)
      } else {
        return PRESENT_NOT_CONTAINED_MESSAGE(guess[ii], st / WORD_LENGTH + 1)
      }
      //console.debug("found present - word=" + wordCopy);
    }
  }

  for (let ii = 0; ii < guess.length; ii++) {
    if (statuses[ii] === 'otherword') {
      let st = ii - (ii % WORD_LENGTH)
      if (st > 0) {
        let ind = wordCopy.substring(0, st).indexOf(guess[ii])
        //console.debug("checking before ii=" + ii + ",char=" + guess[ii] + ", start=" + st + ", ind=" + ind + ", word=" + wordCopy.substring(0, st))
        if (ind !== -1) {
          wordCopy =
            wordCopy.substring(0, ind) + ' ' + wordCopy.substring(ind + 1)
          //console.debug("found other before - word=" + wordCopy);
          continue
        }
      }
      if (st + WORD_LENGTH < WORD_LENGTH * WORD_COUNT) {
        let ind = wordCopy
          .substring(st + WORD_LENGTH, WORD_LENGTH * WORD_COUNT)
          .indexOf(guess[ii])
        //console.debug("checking after " + ind)
        if (ind !== -1) {
          wordCopy =
            wordCopy.substring(0, st + WORD_LENGTH + ind) +
            ' ' +
            wordCopy.substring(st + WORD_LENGTH + ind + 1)
          //console.debug("found other after - word=" + wordCopy);
          continue
        }
      }
      return OTHER_NOT_CONTAINED_MESSAGE(guess[ii], st / WORD_LENGTH + 1)
    }
  }
  /*
  for (let i = 0; i < guess.length; i++) {
    if (statuses[i] === 'correct' || statuses[i] === 'present') {
      lettersLeftArray.push(guess[i])
    }
    if (statuses[i] === 'correct' && word[i] !== guess[i]) {
      return WRONG_SPOT_MESSAGE(guess[i], i + 1)
    }
  }

  // check for the first unused letter, taking duplicate letters
  // into account - see issue #198
  let n
  for (const letter of word) {
    n = lettersLeftArray.indexOf(letter)
    if (n !== -1) {
      lettersLeftArray.splice(n, 1)
    }
  }

  if (lettersLeftArray.length > 0) {
    return NOT_CONTAINED_MESSAGE(lettersLeftArray[0])
  }
 */
  return false
}

export const unicodeSplit = (word: string) => {
  return new GraphemeSplitter().splitGraphemes(word)
}

export const unicodeLength = (word: string) => {
  return unicodeSplit(word).length
}

export const localeAwareLowerCase = (text: string) => {
  return process.env.REACT_APP_LOCALE_STRING
    ? text.toLocaleLowerCase(process.env.REACT_APP_LOCALE_STRING)
    : text.toLowerCase()
}

export const localeAwareUpperCase = (text: string) => {
  return process.env.REACT_APP_LOCALE_STRING
    ? text.toLocaleUpperCase(process.env.REACT_APP_LOCALE_STRING)
    : text.toUpperCase()
}

const primes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59]

export const getWordOfDay = (word_count: number) => {
  // January 1, 2022 Game Epoch
  //const epochMs = new Date('January 1, 2022 00:00:00 EST').valueOf()
  const epochMs = new Date('January 1, 1970 00:00:00 EST').valueOf()
  const now = Date.now()
  const msInDay = 86400000
  const index = Math.floor((now - epochMs) / msInDay)
  const nextday = (index + 1) * msInDay + epochMs
  let primeIndex = 0
  let useNew = index > 20500 // 2026-02-16
  //console.debug('useNew=%s', useNew)

  var WORDS = useNew ? NEW_WORDS : OLD_WORDS

  for (var pp = 0; pp < word_count; pp++) {
    primeIndex = (primeIndex + 1) % primes.length
    while (primes[primeIndex] % WORDS.length === 0) {
      primeIndex = (primeIndex + 1) % primes.length
    }
  }

  let multiplier = primes[primeIndex]
  let theFullWord = ''
  for (var ii = 0; ii < word_count; ii++) {
    theFullWord += WORDS[(index * multiplier) % WORDS.length]
    //console.debug("ii=%s, multiplier=%s, primeIndex=%s, WORDS.length=%s, multiplier%WORDS.length=%s, index=%s", ii, multiplier, primeIndex, WORDS.length, index*multiplier%WORDS.length, index)

    primeIndex = (primeIndex + 1) % primes.length
    while (primes[primeIndex] % WORDS.length === 0) {
      primeIndex = (primeIndex + 1) % primes.length
    }
    multiplier = multiplier * primes[primeIndex]
  }

  var solution = localeAwareUpperCase(theFullWord)
  var correctWord = ''
  for (var jj = 0; jj < word_count; jj++) {
    correctWord +=
      solution.substring(jj * WORD_LENGTH, jj * WORD_LENGTH + WORD_LENGTH) + ' '
  }

  return {
    solution: solution,
    solutionIndex: index,
    tomorrow: nextday,
    correctWord: correctWord,
    WORDS: WORDS,
  }
}

export const { solution, solutionIndex, tomorrow, correctWord, WORDS } =
  getWordOfDay(WORD_COUNT)

export const isWordInWordList = (word: string) => {
  for (var ii = 0; ii < WORD_COUNT; ii++) {
    if (
      !WORDS.includes(
        localeAwareLowerCase(
          word.substring(ii * WORD_LENGTH, ii * WORD_LENGTH + WORD_LENGTH)
        )
      ) &&
      !VALID_GUESSES.includes(
        localeAwareLowerCase(
          word.substring(ii * WORD_LENGTH, ii * WORD_LENGTH + WORD_LENGTH)
        )
      )
    ) {
      return false
    }
  }
  return true
}

export const isValidWord = (word: string) => {
  var valid: boolean =
    WORDS.includes(localeAwareLowerCase(word)) ||
    VALID_GUESSES.includes(localeAwareLowerCase(word))
  return valid
}

export const isWinningWord = (word: string) => {
  return solution === word
}
